const GOOGLE_DOC_URL = 'https://docs.google.com/document/d/13HgkMp5BrHu1hD0gP7RPm8IAumS6Qvv8CsiOJPKvPVE/';

function createElement<K extends keyof HTMLElementTagNameMap>(
    tagName: K,
    className: string,
    text?: string,
): HTMLElementTagNameMap[K] {
    const element = document.createElement(tagName);
    element.className = className;
    if (text) {
        element.textContent = text;
    }
    return element;
}

export function initGoogleDocWidget(): void {
    const button = createElement('button', 'kl-google-doc-button', 'Open doc');
    button.type = 'button';
    button.setAttribute('aria-label', 'Open Google doc');

    const modal = createElement('div', 'kl-google-doc-modal');
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'kl-google-doc-title');

    const panel = createElement('div', 'kl-google-doc-modal__panel');
    const header = createElement('div', 'kl-google-doc-modal__header');
    const title = createElement('strong', '', 'Quick doc check');
    title.id = 'kl-google-doc-title';
    const close = createElement('button', 'kl-google-doc-modal__close', 'Close');
    close.type = 'button';
    header.append(title, close);

    const frame = createElement('iframe', 'kl-google-doc-modal__frame') as HTMLIFrameElement;
    frame.title = 'Google Doc preview';
    const hint = createElement(
        'p',
        'kl-google-doc-modal__hint',
        'Access is controlled by Google sharing settings.',
    );
    panel.append(header, hint, frame);
    modal.append(panel);
    document.body.append(button, modal);

    function hideModal(): void {
        modal.hidden = true;
        frame.src = 'about:blank';
    }

    button.addEventListener('click', () => {
        modal.hidden = false;
        frame.src = GOOGLE_DOC_URL;
    });
    close.addEventListener('click', hideModal);
    modal.addEventListener('click', (event) => {
        if (event.target === modal) {
            hideModal();
        }
    });
}